import { ControlIcons } from 'owa-control-icons';
import { registerAsset, DEFAULT_MIN_ASSET_WIDTH } from 'owa-timestream-asset-sdk';
import { DefaultCommand } from 'owa-timestream-asset-sdk-types';
import ClockView from './components/ClockView';
import type { ClockPayload } from './schema';
import { CLOCK_TYPE } from './constants';
import getLocalizedTitleAndSearchString from './utils/getLocalizedTitleAndSearchString';
import loc from 'owa-localize';
import {
    clockName,
    clockTooltip,
    clockAriaLabel,
    clockErrorMessage,
} from './clockStrings.locstring.json';

export default registerAsset<ClockPayload>({
    type: CLOCK_TYPE,
    iconName: ControlIcons.WorldClock,
    getToolName: () => loc(clockName),
    getTooltip: () => loc(clockTooltip),
    getErrorMessage: () => loc(clockErrorMessage),
    unsupportedDefaultCommands: [DefaultCommand.DueDate, DefaultCommand.Resize],
    CanvasView: ClockView,
    createEmptyAsset: () => ({
        type: CLOCK_TYPE,
        width: DEFAULT_MIN_ASSET_WIDTH,
        payload: {
            timeZones: [],
        },
    }),
    getTitleString: getLocalizedTitleAndSearchString,
    getSearchString: getLocalizedTitleAndSearchString,
    getAriaLabel: (payload: ClockPayload) => loc(clockAriaLabel, payload.timeZones.length),
});
